<div class="toast-container">
  @for (toast of toastService.activeToasts().slice().reverse(); track toast.id) {
  <div class="toast toast-{{ toast.type }}" [attr.data-testid]="'toast-' + toast.type" role="alert">
    <div class="toast-content">
      <span class="toast-message">{{ toast.message }}</span>
      @if (toast.actions && toast.actions.length > 0) {
      <div class="toast-actions">
        @for (action of toast.actions; track $index) {
        <app-button [variant]="'filled'" [color]="'primary'" (click)="handleAction(toast.id, action)"
          [attr.data-testid]="'toast-action-' + action.label.toLowerCase().replace(/\\s+/g, '-')">
          {{ action.label }}
        </app-button>
        }
      </div>
      }
    </div>
    <button class="toast-dismiss" (click)="dismiss(toast.id)" [attr.data-testid]="'toast-dismiss-' + toast.id"
      [attr.aria-label]="'component.toast.dismiss' | translate">
      ✕
    </button>
    @if (toast.autoDismiss && toast.dismissAfter) {
    <app-progress-bar [duration]="toast.dismissAfter" />
    }
  </div>
  }
</div>